export const STORYBOARD_TYPES = {
  LANDING_PAGE: 'LANDING_PAGE',
  RESOURCE_CENTER: 'RESOURCE_CENTER',
  INTERACTIVE_CONTENT: 'INTERACTIVE_CONTENT',
  INTERACTIVE_CONTENT_V2: 'INTERACTIVE_CONTENT_V2',
  SPATIAL: 'SPATIAL'
}

export const INTERACTIVE_CONTENT_TYPES = [
  STORYBOARD_TYPES.INTERACTIVE_CONTENT,
  STORYBOARD_TYPES.INTERACTIVE_CONTENT_V2
];

/* SEGMENT STORYBOARD TYPE */
export const SEGMENT_STORYBOARDS = [
  STORYBOARD_TYPES.LANDING_PAGE,
  STORYBOARD_TYPES.RESOURCE_CENTER,
  STORYBOARD_TYPES.INTERACTIVE_CONTENT_V2
]

/* storyboards which can't strech the whole window size */
export const PAGE_CONTAIN_STORYBOARDS = [
  STORYBOARD_TYPES.SPATIAL,
  STORYBOARD_TYPES.INTERACTIVE_CONTENT,
  STORYBOARD_TYPES.INTERACTIVE_CONTENT_V2
]